import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-cash-on-delivery',
  standalone: true,
  templateUrl: '../../assets/cash-on-delivery.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamCashOnDeliveryIcon {}
